import {BUSCAR_DADOS_VEXADO_BI, LIMPAR_DADOS_VEXADO_BI} from '../../actions/types'

const itemInicial = {
    valorTotalCancelamento: '0',
    valorTotalFaturamento: '0',
    valorTotalLiquido: '0',
    valorTotalImposto: '0',
    valorTotalTicketMedio: '0',
    totalFaturamentoPorRota: [],
    totalFaturamentoPorAgencia: [],
    totalFaturamentoPorEmpresa: [],
    totalAgrupadoPorSituacao: [],
    totalFaturamentoPorVendedor: [],
    totalFaturamentoPorTrecho: [],
    totalFaturamentoPorVeiculo: []
};

export default function reducerVexadoBI(state = itemInicial, action) {
    switch (action.type) {
        case BUSCAR_DADOS_VEXADO_BI: {
            return action.payload;
        }

        case LIMPAR_DADOS_VEXADO_BI: {
            return itemInicial;
        }


        default: {
            return state
        }
    }
}
